// frontend/src/services/feedbackService.js
import { Capacitor } from '@capacitor/core';
import api from './apiClient';

export const FEEDBACK_CATEGORIES = [
  { value: 'idea', label: 'Idea / suggestion' },
  { value: 'bug', label: 'Something is broken' },
  { value: 'praise', label: 'Something I love' },
  { value: 'other', label: 'Other' },
];

// 'android' | 'ios' | 'web'
export function detectPlatform() {
  try {
    const platform = Capacitor.getPlatform();
    return platform === 'android' || platform === 'ios' ? platform : 'web';
  } catch {
    return 'web';
  }
}

async function detectAppVersion() {
  try {
    if (Capacitor.isNativePlatform()) {
      const { App } = await import('@capacitor/app');
      const info = await App.getInfo();
      return info?.version || null;
    }
  } catch {
    // fall through
  }
  return null;
}

// Builds the request body; platform/version/screen are added automatically.
export async function buildFeedbackPayload({ message, category = 'other', rating = null }, screen = '') {
  return {
    message: (message || '').trim(),
    category,
    rating: rating || null,
    platform: detectPlatform(),
    app_version: await detectAppVersion(),
    screen,
  };
}

export async function submitFeedback(fields, screen = window.location.pathname) {
  const payload = await buildFeedbackPayload(fields, screen);
  const { data } = await api.post('/api/feedback/', payload);
  return data;
}
